/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from "react"
import logo from "../pageComponents/images/logo-edison.svg"
import facebook from '../pageComponents/images/credits/facebook.svg'
import twitter from '../pageComponents/images/credits/twitter.svg'
import youtube from '../pageComponents/images/credits/youtube.svg'
import linkedin from '../pageComponents/images/credits/linkedin.svg'
import instagram from '../pageComponents/images/credits/instagram.svg'
import frecciaBlu from '../pageComponents/images/freccia-blu.svg'
import videoIcon from '../pageComponents/images/credits/video-credits.svg'
import frecciaIcon from '../pageComponents/images/credits/freccia-credits.svg'
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from "react-share";

const origin = typeof window !== "undefined" ? window.location.origin : ""
const shareUrl = 'https://stories.efficienzaenergetica.edison.it/fleet-audit'

const CreditsMobile = ({ backgroundColor, openPercent, color, innerRef, navigate }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8 min-h-100 md:h-100">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='d-flex mt-3'>
          <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
            Le soluzioni<br />
            energetiche<br />
            di Edison<br />
          </div>
          <div className='ml-5 md:ml-20'>
            <a
              href={'https://www.youtube.com/watch?v=Q28IO29ESqw&feature=youtu.be'}
              target='_blank'
              rel="noopener noreferrer"
              className='video-icon'>
              <img className='ml-1' src={videoIcon} alt='Video' />
            </a>
          </div>
        </div>
        <div className='d-flex mt-5'>
          <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
            Fleet Audit <br />
            e servizi per <br />
            le aziende <br />
          </div>
          <div className='ml-5 md:ml-20'>
            <a
              href={'https://www.efficienzaenergetica.edison.it/offerta/o/mobilita-elettrica/'}
              target='_blank'
              rel="noopener noreferrer"
              className='video-icon'>
              <img className='ml-1' src={frecciaIcon} style={{ transform: 'rotate(-45deg)' }} alt='Video' />
            </a>
          </div>
        </div>
        <div className='d-flex mt-5'>
          <div>
            <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
              Torna su
            </div>
            <div className='mt-2'>
              <img className='ml-1' src={frecciaIcon} style={{ transform: 'rotate(-90deg)' }} alt='Torna su' onClick={() => navigate("/")}/>
            </div>
          </div>
          <div className='ml-10 md:ml-25'>
            <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
              Share
            </div>
            <div className='d-flex social-link mt-2'>
              <img src={frecciaBlu} alt='Freccia orange' style={{ transform: 'rotate(-45deg)' }} />
              <div className='ml-1 md:font-18 font-16 line-height-22'>
                <LinkedinShareButton url={shareUrl}>Linkedin</LinkedinShareButton>
              </div>
            </div>
            <div className='mt-1 d-flex social-link'>
              <img src={frecciaBlu} alt='Freccia orange' style={{ transform: 'rotate(-45deg)' }} />
              <div className='ml-1 md:font-18 font-16 line-height-22'>
                <FacebookShareButton url={shareUrl}>Facebook</FacebookShareButton>
              </div>
            </div>
            <div className='mt-1 d-flex social-link'>
              <img src={frecciaBlu} alt='Freccia orange' style={{ transform: 'rotate(-45deg)' }} />
              <div className='ml-1 md:font-18 font-16 line-height-22'>
                <TwitterShareButton url={shareUrl}>Twitter</TwitterShareButton>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex mt-5'>
          <div>
            <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
              Dove siamo
            </div>
            <div className='font-14 md:font-18 line-height-18 mt-1'>
              Edison Spa <br />
              Foro Buonaparte 31<br />
              20121 Milano, Italia
            </div>
          </div>
          <div className='ml-4 md:ml-19'>
            <div className='font-22 md:font-30 font-family-acumin font-weight-500 line-height-28'>
              Contatti
            </div>
            <div className='font-14 md:font-20 line-height-18 mt-1'>
              <div><img src={frecciaBlu} alt='Freccia orange' style={{ transform: 'rotate(-45deg)' }} /> </div>
              <a rel="noopener noreferrer" target='_blank' href={'https://www.efficienzaenergetica.edison.it/contatti/'} className='link md:font-18 font-14'>
                Scrivici un messaggio, <br />
                ti ricontatteremo noi
              </a>
            </div>
          </div>
        </div>
        <div className='d-flex mt-4 pb-5'>
          <div>
            <img width={86} src={logo} alt='Edison' />
          </div>
          <div style={{ width: 150 }} className='ml-6 md:ml-31 mt-1 d-flex justify-content-between'>
            <a href='https://www.facebook.com/EdisonS.p.a/' rel="noopener noreferrer" target='_blank'><img style={{ color: 'orange' }} src={facebook} alt={'Facebook'} /></a>
            <a href='https://twitter.com/EdisonNews?s=20' rel="noopener noreferrer" target='_blank'><img src={twitter} alt={'Twitter'} /></a>
            <a href='https://www.instagram.com/edison_onoff/' rel="noopener noreferrer" target='_blank'><img src={instagram} alt={'Instagram'} /></a>
            {/* <a href='https://www.youtube.com/channel/UCOzAKqdXJYVeuvv_kCxsXiA' rel="noopener noreferrer" target='_blank'><img src={youtube} alt={'Youtube'} /></a> */}
            <a href='https://www.linkedin.com/company/edison-spa/?originalSubdomain=it' rel="noopener noreferrer" target='_blank'><img src={linkedin} alt={'Linkedin'} /></a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreditsMobile
